import request from '../../utils/request';
import { Search } from '../../DTOS/AccessControlEmployer/Search';

const AccessControlEmployerService = {
  search: (search: Search) => {
    return request('/accessControlEmployer/search', {
      method: 'POST',
      body: JSON.stringify({ request: { ...search } }),
    });
  },

  upsert: (
    id: any,
    formData: {
      name: any;
      cardReference: any;
      faceReference: any;
    }
  ) => {
    return request('/accessControlEmployer/upsert', {
      method: 'POST',
      body: JSON.stringify({
        request: {
          id: id,
          name: formData.name,
          cardReference: formData.cardReference,
          faceReference: formData.faceReference
        },
      }),
    });
  },
};

export default AccessControlEmployerService;
